export default "__VITE_ASSET__BIbCbmLo__"